import { createSlice } from '@reduxjs/toolkit'
import {
  getNavMenuConfigAsync,
  saveNavMenuVersionAsync,
  publishNavMenuVersionAsync,
  rollbackNavMenuVersionAsync,
  getDefaultNavMenuConfigAsync,
} from 'src/redux/async/navMenuConfig/navMenuConfigAsync'

const initialState = {
  activeVersion: null,
  history: [],
  loader: false,
  loading: false,
  saving: false,
  publishing: false,
  rollingBack: false,
  error: null,
}

const navMenuConfigSlice = createSlice({
  name: 'navMenuConfig',
  initialState,
  reducers: {
    resetNavMenuConfig: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getDefaultNavMenuConfigAsync.pending, (state) => {
        state.loader = true
        state.error = null
      })
      .addCase(getDefaultNavMenuConfigAsync.fulfilled, (state, action) => {
        state.loader = false
        state.activeVersion = action.payload?.data ? { config: action.payload.data } : null
      })
      .addCase(getDefaultNavMenuConfigAsync.rejected, (state) => {
        state.loader = false
        state.error = 'Failed to load navigation menu configuration.'
      })
      .addCase(getNavMenuConfigAsync.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getNavMenuConfigAsync.fulfilled, (state, action) => {
        state.loading = false
        state.activeVersion = action.payload?.data?.activeVersion ?? null
        state.history = action.payload?.data?.history ?? []
      })
      .addCase(getNavMenuConfigAsync.rejected, (state) => {
        state.loading = false
        state.error = 'Failed to load navigation menu configuration.'
      })
      .addCase(saveNavMenuVersionAsync.pending, (state) => {
        state.saving = true
      })
      .addCase(saveNavMenuVersionAsync.fulfilled, (state) => {
        state.saving = false
      })
      .addCase(saveNavMenuVersionAsync.rejected, (state) => {
        state.saving = false
      })
      .addCase(publishNavMenuVersionAsync.pending, (state) => {
        state.publishing = true
      })
      .addCase(publishNavMenuVersionAsync.fulfilled, (state) => {
        state.publishing = false
      })
      .addCase(publishNavMenuVersionAsync.rejected, (state) => {
        state.publishing = false
      })
      .addCase(rollbackNavMenuVersionAsync.pending, (state) => {
        state.rollingBack = true
      })
      .addCase(rollbackNavMenuVersionAsync.fulfilled, (state) => {
        state.rollingBack = false
      })
      .addCase(rollbackNavMenuVersionAsync.rejected, (state) => {
        state.rollingBack = false
      })
  },
})

export const { resetNavMenuConfig } = navMenuConfigSlice.actions
export default navMenuConfigSlice.reducer
